/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import Loader from '../loaders/loader'
import http from '../Interceptor/Interseptor'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import $ from 'jquery'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import Sort from '../Pagination/Sort'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import {message, Icon} from 'antd'
import AutoComplete from '../BaseComponent/autocomplete'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import SearchableCombo from '../BaseComponent/searchableCombo'

class ParcelLabel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      multiProvider: [],
      providerArr: [],
      providerId: '',
      providers: [],
      finalStocks: [],
      arrayOfStocks: [],
      sortBy: 'orderId_asc',
      date: moment().add(1, 'day'),
      defaultValueDate: true,
      items: [],
      itemsToShow: [],
      driverId: '',
      sortData: [
        {
          name: 'انتخاب',
          value: 'select',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'ردیف',
          value: 'row',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کد محصول',
          value: 'articleId',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام محصول',
          value: 'title',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'بارکد محصول',
          value: 'code',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'مقدار',
          value: 'qty',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'واحد',
          value: 'unitTitle',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'وزن (کیلوگرم)',
          value: 'weight',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      operators: [],
      selectedItems: [],
      selectedOperatorId: null,
      allItemsSelected: false
    }
  }

  getStocks = (arrayOfStocks) => {
    var stockArr = []

    this.setState({
      arrayOfStocks
    })

    if (arrayOfStocks.length == '0') {
      this.setState({
        finalStocks: []
      })
    } else {
      for (let prop of arrayOfStocks) {
        stockArr.push(prop.value)
        this.setState({
          finalStocks: stockArr
        })
      }
    }
  }

  finalStocks = (finalStocks) => {
    let array = []
    finalStocks.forEach((item) => {
      array.push(item.stockProductId)
    })
    this.setState({
      finalStocks: array
    })
  }

  async filter() {
    if (this.state.date === null) {
      message.error('تاریخ الزامی است')
    } else {
      $('#article-id').val('')
      $('#product-name').val('')
      $('#product-code').val('')
      await this.getReport()
    }
  }

  createFilter = () => {
    let filter = {
      stockProductIds: [],
      providerIds: []
    }
    let {date} = this.state
    let {finalStocks} = this.state
    let providerId = this.state.providerId

    if (providerId) {
      filter.providerId = providerId
    }
    if (finalStocks.length !== 0) {
      filter.stockProductIds = finalStocks.join(',')
    }
    if (date) {
      filter.fromTime = this.epochFrom(date)
      filter.toTime = this.epochTo(date)
    }
    return filter
  }

  getReport = () => {
    let filter = this.createFilter()
    if (filter.fromTime === null && filter.toTime === null) {
      message.error('تاریخ الزامی است')
    } else if (!filter.providerId) {
      message.error('فیلتر تامین کننده الزامی است')
    } else {
      this.setState({
        loading: true
      })

      http
        .get(`${REPORT_DISPATCH.REPORT_DISPATCH_CART_PRODUCTS_JASON}`, {
          params: filter
        })
        .then((response) => {
          if (response.data.error == null) {
            this.setState({
              items: response.data.object.map((item) => {
                return {
                  ...item,
                  weightKg: item.weight ? item.weight / 1000 : null,
                  checked: false
                }
              }),
              itemsToShow: response.data.object.map((item) => {
                return {
                  ...item,
                  weightKg: item.weight ? item.weight / 1000 : null,
                  checked: false
                }
              }),
              selectedItems: [],
              allItemsSelected: false,
              loading: false
            })
          } else {
            this.setState({
              loading: false,
              items: [],
              itemsToShow: [],
              selectedItems: [],
              allItemsSelected: false
            })
          }
        })
        .finally(() => {
          this.setState({
            loading: false
          })
        })
    }
  }

  createJasperFilter = (articleIds = null) => {
    const filter = {}
    const {items, selectedItems, providerId, date} = this.state

    const articleIdsToPick = articleIds && articleIds.length ? articleIds : selectedItems

    if (articleIdsToPick && articleIdsToPick.length) {
      filter.stockProductIds = items.reduce((stockProductIds, item) => {
        if (articleIdsToPick.includes(item.articleId)) stockProductIds.push(item.stockProductId)

        return stockProductIds
      }, [])
    }

    if (providerId) {
      filter.providerIds = providerId
    }

    if (date) {
      filter.fromTime = this.epochFrom(date)
      filter.toTime = this.epochTo(date)
    }

    return filter
  }

  printJasperReport = (articleIds = null, assigneeId = null, reloadReport = false) => {
    const filter = this.createJasperFilter(articleIds)

    JASPERREPORT(
      `report/jasper/dispatch/cart/products/jasper?fromTime=${filter.fromTime}&toTime=${
        filter.toTime
      }&stockProductIds=${filter.stockProductIds}&providerIds=${filter.providerIds}${
        assigneeId ? `&assigneeId=${assigneeId}` : ''
      }`
    )

    if (reloadReport) {
      this.getReport()
    }
  }

  componentDidMount() {
    this.getProviders()
    this.getOperators()
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })
  }

  getProviders = () => {
    return http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var result = response.data.object
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].providerId
            result[i]['label'] = '' + result[i].providerId + ' - ' + result[i].title
          }
          this.setState({
            providers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  getOperators = () => {
    return http.get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {}).then((response) => {
      if (response.data.error === null) {
        var operators = response.data.object
        for (let i = 0; i < operators.length; i++) {
          operators[i]['value'] = operators[i].personId
          operators[i]['label'] = operators[i].personId + ' - ' + operators[i].name
        }
        this.setState({
          operators: response.data.object
        })
      }
    })
  }

  getOperatorValue = (id) => {
    if (id === null) {
      this.setState({
        selectedOperatorId: ''
      })
    } else {
      this.setState({
        selectedOperatorId: id
      })
    }
  }

  handleChangeProvider = (multiProvider) => {
    var providerArr = []
    this.setState({multiProvider})
    if (multiProvider.length == '0') {
      this.setState({
        providerArr: []
      })
    } else {
      for (let prop of multiProvider) {
        providerArr.push(prop.providerId)
        this.setState({
          providerArr: providerArr
        })
      }
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  epochFrom = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  epochTo = (x) => {
    var jalaiDate = this.convertDigit(jMoment(x).format('jYYYY/jMM/jDD'))
    var concatDayMount = jalaiDate.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = moment(x, 'jYYYY/jM/jD').format('YYYY/MM/D')
    let from = miladiDate + ' ' + '23:59:00'
    let fromEpoch = moment.utc(from).valueOf()

    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
    // return fromEpoch - (3.5 * 3600 * 1000);
  }

  date(props) {
    return <input className="form-control" {...props} />
  }

  handleDateChange = (date) => {
    this.setState({
      date
    })
  }

  toggleCheck = (articleId, checked) => {
    let items = this.state.items
    let itemsToShow = this.state.itemsToShow
    let selectedItems = this.state.selectedItems

    if (!checked) {
      selectedItems.push(articleId)
    } else {
      selectedItems = selectedItems.filter((item) => item !== articleId)
    }

    const index = items.findIndex((item) => item.articleId === articleId)
    items[index].checked = !checked

    const indexItemsToShow = itemsToShow.findIndex((item) => item.articleId === articleId)
    if (indexItemsToShow !== -1) itemsToShow[indexItemsToShow].checked = !checked

    this.setState({
      items,
      selectedItems,
      allItemsSelected: items.length === selectedItems.length
    })
  }

  toggleSelectAll = () => {
    let {items, allItemsSelected, selectedItems, itemsToShow} = this.state

    items = items.map((item) => {
      return {
        ...item,
        checked: !allItemsSelected
      }
    })
    selectedItems = allItemsSelected ? [] : items.map((item) => item.articleId)
    allItemsSelected = !allItemsSelected

    const itemsToShowIds = itemsToShow.map((item) => item.articleId)
    itemsToShow = items.filter((item) => itemsToShowIds.includes(item.articleId))

    this.setState({
      items,
      itemsToShow,
      selectedItems,
      allItemsSelected
    })
  }

  assignToOperator() {
    if (!this.state.selectedOperatorId) {
      message.error('اپراتور را انتخاب کنید')
      return
    }

    if (!this.state.selectedItems.length) {
      message.error('حداقل یک مورد باید انتخاب شود')
      return
    }

    const arrangements = this.state.items.reduce((arrangements, item) => {
      if (this.state.selectedItems.includes(item.articleId)) {
        arrangements.push({
          articleId: item.articleId,
          sellerId: item.sellerId,
          quantity: item.quantity,
          weight: item.weight
        })
      }
      return arrangements
    }, [])

    if (arrangements.length) {
      const data = {
        date: this.epochFrom(this.state.date),
        userId: this.state.selectedOperatorId.personId,
        arrangements
      }

      http.post('public/cartStationArrangement/create', data, {}).then((res) => {
        if (res.data.error === null) {
          this.setState(
            {
              selectedItems: []
            },
            () => {
              message.success('با موفقیت انجام شد')
              this.printJasperReport(
                arrangements.map((item) => item.articleId),
                this.state.selectedOperatorId.personId,
                true
              )
            }
          )
        }
      })
    }
  }

  localFilter() {
    const articleId = $('#article-id')
      .val()
      .trim()
    const productName = $('#product-name')
      .val()
      .trim()
    const productCode = $('#product-code')
      .val()
      .trim()

    if (articleId === '' && productName === '' && productCode === '') {
      this.setState({
        itemsToShow: this.state.items
      })

      return
    }

    const {items} = this.state

    const itemsToShow = items.filter(
      (item) =>
        (productName !== '' ? item.title.includes(productName) : true) &&
        (articleId !== '' ? item.articleId === Number(articleId) : true) &&
        (productCode !== '' ? item.code.includes(productCode) : true)
    )

    this.setState({
      itemsToShow
    })
  }

  render() {
    let {loading} = this.state

    return (
      <div className="rtl printA4Page mx-3">
        <Loader show={loading} />

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>سفارش تامین کنندگان</li>
            <li>فرم چیدمان</li>
          </ul>

          <div className="basketFilterComponent">
            <div className="filterInputs">
              <div className="formComponent">
                <label className="font-weight-bold">
                  تاریخ :<span className="requireFiled font-weight-bold">*</span>
                </label>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                  <DatePicker
                    inline
                    okLabel="تأیید"
                    autoOk={true}
                    leftArrowIcon={<Icon type="left" />}
                    rightArrowIcon={<Icon type="right" />}
                    cancelLabel="لغو"
                    labelFunc={(date) => (date == null ? '' : date.format('jYYYY/jMM/jDD'))}
                    value={this.state.date}
                    id="date"
                    onChange={this.handleDateChange}
                    TextFieldComponent={this.date}
                    readOnly
                  />
                </MuiPickersUtilsProvider>
              </div>

              <div className="formComponent selectComponent">
                <AutoComplete
                  label="تامین کننده"
                  api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                  textField="title"
                  valueField="providerId"
                  required
                  id="provider"
                  value={this.state.providerId}
                  setValue={(providerId) => this.setState({providerId})}
                />
              </div>

              <div>
                <label className="invisible mb-4 d-block">اطلاع رسانی</label>

                <button className="confirmFilter " onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            {this.state.items.length !== 0 && (
              <div className="container-fluid">
                <hr className="mb-0" />

                <div className="row">
                  <div className="col-2 p-2">
                    <div className="formComponent">
                      <SearchableCombo
                        options={this.state.operators}
                        getValueCombo={this.getOperatorValue}
                        lableText="اپراتور"
                        placeholder="------"
                        isClearable={true}
                        isMulti={false}
                        className="font-weight-bold"
                      />
                    </div>
                  </div>

                  <div className="col-2 p-2">
                    <div>
                      <label className="invisible mb-4">اطلاع رسانی</label>
                      <span
                        onClick={() => this.assignToOperator()}
                        style={{background: '#f7a732', border: '1px solid #f7a732'}}
                        className="searchCustommer"
                      >
                        اعمال
                      </span>
                    </div>
                  </div>

                  <div className="col-2 p-2">
                    <label className="invisible mb-4 d-block">اطلاع رسانی</label>
                    <button
                      disabled={this.state.selectedItems.length === 0}
                      className="printButton w-75 mt-0"
                      onClick={() => this.printJasperReport()}
                    >
                      چاپ موارد انتخاب شده
                    </button>
                    <p className="errorText mx-3" id="errorText" />
                  </div>
                </div>

                <hr className="mb-0" />

                <div className="filterInputs">
                  <div className="formComponent">
                    <label>کد محصول</label>
                    <input className="form-control" id="article-id" type="text" />
                  </div>

                  <div className="formComponent">
                    <label>نام محصول</label>
                    <input className="form-control" id="product-name" type="text" />
                  </div>

                  <div className="formComponent">
                    <label>بارکد محصول</label>
                    <input className="form-control" id="product-code" type="text" />
                  </div>

                  <div>
                    <label className="invisible mb-4 d-block">اطلاع رسانی</label>

                    <button
                      className="confirmFilter"
                      style={{paddingRight: 20, paddingLeft: 20}}
                      onClick={() => this.localFilter()}
                    >
                      فیلتر
                    </button>
                  </div>
                </div>

                <div className="row">
                  <div className="p-2 d-flex flex-row justify-content-center align-items-center  align-content-end ml-5">
                    {this.state.allItemsSelected ? (
                      <img
                        width={20}
                        onClick={() => this.toggleSelectAll()}
                        src={require('../../image/checkbox.svg')}
                      />
                    ) : (
                      <img
                        width={20}
                        onClick={() => this.toggleSelectAll()}
                        src={require('../../image/unCheckBox.png')}
                      />
                    )}
                    <label className="small mx-2" style={{marginTop: 10}}>
                      انتخاب همه
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>

          {this.state.items.length > 0 ? (
            <div className="showBaseTable">
              <table className="baseTable">
                <Sort data={this.state.sortData} getSort={this.getSort} />
                <tbody>
                  {this.state.itemsToShow.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <span onClick={() => this.toggleCheck(item.articleId, item.checked)}>
                          {item.checked && <img src={require('../../image/checkbox.svg')} />}
                          {!item.checked ? <img src={require('../../image/unCheckBox.png')} /> : null}
                        </span>
                      </td>
                      <td>{index + 1}</td>
                      <td>{item.articleId}</td>
                      <td>{item.title}</td>
                      <td>{item.code}</td>
                      <td>{item.quantity}</td>
                      <td>{item.unitTitle}</td>
                      <td>{item.weightKg}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}

export default ParcelLabel
